const ForwardIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.62708 16.9375V5.9375L14.6271 11.4375L8.62708 16.9375Z" stroke="currentColor" shapeRendering="crispEdges"/>
            <line x1="15.8729" y1="4.82812" x2="15.8729" y2="18.0781" stroke="currentColor"/>
        </svg>

    )
}

export default ForwardIcon
